import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import useWindowSize from "./useWindowSize";
import './sidebar.css'

export default function SidebarItem({ item, activeTab, setActiveTab }) {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const size = useWindowSize();
    const handleItems = async (title) => {
        if (item.path === "/logout") {
            await logout();
        } else {
            setActiveTab(title)
            navigate(item.path);
        }
    };

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {item.title}
        </Tooltip>
    );

    const isSmallScreen = size.width <= 767;

    if (item.childrens) {
        return (
            <div className="sidebar-item open px-3">
                <div className="sidebar-title mt-2 text-nowrap">
                    <span className="cursor_pointer">
                        {item.icon && (
                            isSmallScreen ? (
                                <OverlayTrigger placement="right" overlay={renderTooltip}>
                                    <i className={`${item.icon} me-2`}></i>

                                </OverlayTrigger>
                            ) : (
                                <i className={`${item.icon} me-2`}></i>
                            )
                        )}
                        <span className="d-none d-md-inline">{item.title}</span>
                    </span>
                </div>
                <div className="sidebar-content justify-content-center text-start text-nowrap">
                    {item.childrens.map((child, index) => (
                        <SidebarItem key={index} item={child} activeTab={activeTab} setActiveTab={setActiveTab} />
                    ))}
                </div>
            </div>
        );
    }
    else {
        return (
            isSmallScreen ? (
                <OverlayTrigger placement="right" overlay={renderTooltip}>
                    <div
                        onClick={() => handleItems(item.title)}
                        className={`sidebar-itemm plain text-nowrap cursor_pointer ${item.path === "/logout" ? "logout-text" : "default-text"}  ${activeTab === item.title && "sidebar-active"}`}
                    >
                        {item.icon && <i className={`${item.icon} me-2`}></i>}
                        <span className="d-none d-md-inline">{item.title}</span>
                    </div>
                </OverlayTrigger>
            ) : (
                <div
                    onClick={() => handleItems(item.title)}
                    className={`sidebar-itemm plain text-nowrap cursor_pointer ${item.path === "/logout" ? "logout-text" : "default-text"} ${activeTab === item.title && "sidebar-active"}`}
                >
                    {item.icon && <i className={`${item.icon} me-2`}></i>}
                    <span className="d-none d-md-inline">{item.title}</span>
                </div>
            )
        );
    }
}